<template>
  <b-row class="p-3">
    <b-col lg="3" sm="3" class="px-0 bg-light">
      <b-img v-if="!loading" :src="imageURL || defaults.imageURL" alt="Image" fluid class="rounded align-items-center" />
      <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100px;">
        <b-spinner type="grow" variant="primary" />
      </div>
    </b-col>
    <b-col lg="9" sm="9" class="pt-1 bg-light">
      <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"><strong>{{ title || defaults.title
          }}</strong></div>
      <div><a :href="url" target="_blank" class="text-muted">{{ domain }}</a></div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '-',
    },
    url: {
      type: String,
      default: 'https://example-real-links.io/',
    },
    imageURL: {
      type: String,
      default: 'https://placehold.co/108x72',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaults() {
      return {
        title: '-',
        url: 'https://example-real-links.io/',
        imageURL: 'https://placehold.co/108x72',
      };
    },
    domain() {
      try {
        return new URL(this.url || this.defaults.url).hostname;
      } catch (e) {
        return '-';
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/ContentShareLink.vue